import Utils from "./utils-service.js";
import { throwError } from "../errors.js";

import jQuery from 'jquery';

export default class Validation {
    constructor(lib) {
        this.ctx = lib.ctx;
        this.router = lib.router;
    }

    init() {
        var self = this;
        jQuery.validator.addMethod("sdpMinAge", function (value, element, param) {
            const yrOnly = element.dataset.mask == '####';
            const age = self.getNoOfYearsFromDate(value, yrOnly);
            return age >= param;
        });
        jQuery.validator.addMethod("sdpMaxAge", function (value, element, param) {
            const yrOnly = element.dataset.mask == '####';
            const age = self.getNoOfYearsFromDate(value, yrOnly);
            if (Utils.isTruthy(element.dataset['max_year_allow_current']))
                return age <= param;

            return age < param;
        });

        jQuery.validator.addMethod("sdpMinDay", function (value, element, param) {
            const days = self.getNoOfDaysFromDate(value);
            if (days == null)
                return true;
            return days >= param;
        });
        jQuery.validator.addMethod("sdpMaxDay", function (value, element, param) {
            let days = self.getNoOfDaysFromDate(value);
            if (days == null)
                return true;
            return days <= param;
        });

        jQuery.validator.addMethod("farmersMultiBrand", function (value, element, param) {
            let uuid = element.dataset.uid
            let input = self.ctx.getters.funnel.elements[uuid];
            let adUids = input.additional_consent.filter(cuid => cuid.includes('in_consent_brand_'));
            let checkedBrands = [];

            adUids.forEach((a_c) => {
                console.log(a_c, self.ctx.getters.funnel.elements[a_c].value);
                if (!checkedBrands.includes(a_c) && (self.ctx.getters.funnel.elements[a_c].value[0] != 'no' && self.ctx.getters.funnel.elements[a_c].value.length != 0)) {
                    checkedBrands.push(a_c)
                }
            });
            if (checkedBrands.length == 0) {
                return false
            }
            if (checkedBrands.length > 0) {
                return true
            }
            
        });
    }

    getNoOfYearsFromDate(strDate, yrOnly = false) {
        let _strDate = strDate;
        if (yrOnly)
            _strDate = strDate + '-01-01';
        const date = new Date(_strDate);
        const today = new Date();
        let age = today.getFullYear() - date.getFullYear();
        const monthDiff = today.getMonth() - date.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < date.getDate())) {
            age--;
        }
        return age;
    }

    getNoOfDaysFromDate(strDate) {
        let days = null;
        let pattern = Utils.$simpleDatePattern;
        if (pattern.test(strDate)) {
            const date = new Date(strDate);
            const today = new Date();
            const timeDiff = date.setHours(0, 0, 0, 0) - today.setHours(0, 0, 0, 0);
            days = Math.ceil(timeDiff / (1000 * 3600 * 24));
        }
        return days;
    }
}